/*
 * @description: 学习达人 
 * @Author: songyang 
 * @Date: 2020-06-09 15:46:47 
 * @LastModifiedBy: songyang 
 * @LastModifiedTime: 2020-06-09 15:46:47 
 */

import Loadable from 'react-loadable';
import React, { Component } from 'react';
const Handle = Loadable({
  loader: () => import('../../component/Mine/StudyStar'),
  loading: () => null,
})

export default class StudyStar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <Handle />
  }
}
